export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()

  const v2ApiNuxtEndpointPlugin = async (
    endpointName: string,
    params: object,
  ): Promise<any> => {
    try {
      const { $i18n } = useNuxtApp()

      const endpointUrl = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/${endpointName}`
      let headers: HeadersInit = useRequestHeaders(['cookie']) as HeadersInit

      headers = {
        ...headers,
        language: $i18n.locale.value,
      }

      const { data } = await useFetch(endpointUrl, { params, headers })

      return data.value
    } catch (errorApi) {
      // eslint-disable-next-line no-console
      console.error('errorApi', errorApi)
    }
  }

  const v2ApiNuxtEndpointPostPlugin = async (
    endpointName: string,
    params: object,
  ): Promise<any> => {
    try {
      const { $i18n } = useNuxtApp()

      const endpointUrl = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/${endpointName}`
      let headers: HeadersInit = useRequestHeaders(['cookie']) as HeadersInit

      headers = {
        ...headers,
        language: $i18n.locale.value,
      }
      const { data } = await useFetch(endpointUrl, {
        body: params,
        headers,
        method: 'POST',
      })

      return data.value
    } catch (errorApi) {
      // eslint-disable-next-line no-console
      console.error('errorApi', errorApi)
    }
  }

  return {
    provide: {
      v2ApiNuxtEndpointPlugin,
      v2ApiNuxtEndpointPostPlugin,
    },
  }
})
